module.exports = __webpack_public_path__ + "img/document_icon.86882190.png";